import { FC } from 'react'
import { Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { Activity, MonitoringSpecialistAssignmentOutdoorActivityType } from '../../../../../api/models'
import { ActivityTypeDisplayNames } from '../../EngagementDetailsEnums'
import SpecialistIcon from '../../../../../assets/images/specialist-icon.svg?react'
import { EngagementTagDetails } from '../../EngagementInfoBox/EngagementTagDetails'
import { ActivityDurationButton } from './ActivityDurationButton'

interface SystemOrAutoClearActivityHeaderProps {
  activityType: Activity['type']
  isPlayingChapter: boolean
  durationMs: number
  assignedSpecialist: string[]
}

export const SystemOrAutoClearActivityHeader: FC<SystemOrAutoClearActivityHeaderProps> = ({
  activityType,
  isPlayingChapter,
  durationMs,
  assignedSpecialist
}) => (
  <Stack
    direction="row"
    sx={{
      gap: 'var(--spacing-s)',
      alignItems: 'center',
      width: '100%'
    }}
    data-testid={`activity-card-system-generated-${activityType}`}
  >
    <ActivityDurationButton isPlayingChapter={isPlayingChapter} durationMs={durationMs} />
    <Typography sx={{ fontWeight: '700', flex: 1 }}>{ActivityTypeDisplayNames[activityType]}</Typography>
    {activityType === MonitoringSpecialistAssignmentOutdoorActivityType.MonitoringSpecialistAssignment && (
      <EngagementTagDetails details={assignedSpecialist} shouldShowCopyIcon={false} shouldTruncateDetail={false} icon={<SpecialistIcon />} />
    )}
  </Stack>
)
